import Vue from 'vue';

import { router } from '@/router';
import store from './store';
import axios from 'axios';

import Master from '@/layouts/Master.vue';
import LandingLayout from '@/layouts/LandingLayout.vue';
import SideNavLayout from '@/layouts/SideNavLayout.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';

import VueFilterDateFormat from 'vue-filter-date-format';
import moment from 'moment';
import vSelect from 'vue-select';
import { month_options } from '@/variables';
import VModal from 'vue-js-modal';
import './index.css';

import 'vue-search-select/dist/VueSearchSelect.css';
import 'nprogress/nprogress.css';

import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

// Registering Layouts
Vue.component('landing-layout', LandingLayout);
Vue.component('default-layout', SideNavLayout);
Vue.component('dashboard-layout', DashboardLayout);

Vue.config.productionTip = false;
Vue.use(VueFilterDateFormat);
Vue.use(VModal);
Vue.use(VueTour)
Vue.component('v-select', vSelect);

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (!store.getters.loggedIn) {
			next({
				name: 'login',
			});
		} else {
			next();
		}
	} else if (to.matched.some(record => record.meta.requiresGuest)) {
		// this route requires auth, check if logged in
		// if yes, redirect to home page.
		if (store.getters.loggedIn) {
			next({
				name: 'home',
			});
		} else {
			next();
		}
	} else {
		next(); // make sure to always call next()!
	}
});

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value))
			.locale('ru')
			.format('DD MMMM YYYY г. hh:mm');
	}
});

Vue.filter('formatDateTwo', function(value) {
	if (value) {
		//return moment(String(value)).locale('ru').format('DD MMMM YYYY г.');
		return moment(String(value)).format('DD.MM.YYYY');
	}
});

Vue.filter('getMonth', function(value) {
	let month_name = '';
	for (const element of month_options) {
		if (element.value === value) {
			month_name = element.name;
		}
	}
	return month_name;
});

Vue.filter('getNumberFormat', function(value) {
	if (value === '-') {
		return value;
	}
	if (typeof value === 'number') {
		value = value.toFixed(2);
		
		return new Intl.NumberFormat('ru-RU').format(value);
	}
	return value;
});

Vue.filter('getNumberFormatTmz', function(value) {
	if (value === '-') {
		return value;
	}
	if (typeof value === 'number') {
		value = (Math.round(value * 100) / 100).toFixed(4);
		
		return new Intl.NumberFormat('ru-RU', {
			minimumFractionDigits: 4
		}).format(value);
		// return value;
	}
	return value;
});



Vue.filter('splitNumber', function(value) {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
});

Vue.filter('TitleCase', value => {
	return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
});

new Vue({
	store,
	router,
	axios,
	render: h => h(Master),
}).$mount('#app');
